export default __webpack_public_path__ + "2ed31b183a07f74897de1c6c9174cd25.png";